import React, {Component} from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import styles from './InfoBox.css';

export default class InfoBox extends Component {
    render() {
        const {label, icon} = this.props;

        return (
            <div className={styles.wrapper}>
                <span className={styles.label}>
                    {label}
                </span>
                {this.props.children}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/InfoBox/InfoBox.js